




































































































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import { SpecOutDetailsModule } from '@/store/modules/specOutDetails';
import SpecOutDto from '@/models/SpecOuts/SpecOutDto';
import UpdateSpecOutGeneralDetailsRequest from '@/models/SpecOuts/UpdateSpecOutGeneralDetailsRequest';
import DeskDto from '@/models/Desks/DeskDto';
import BranchDto from '@/models/Branches/BranchDto';

@Component({
    name: 'SpecOutGeneralDetailsEdit'
})
export default class SpecOutGeneralDetailsEdit extends GiganautVueDialog {

  entity: SpecOutDto = new SpecOutDto();
  desks: DeskDto[] = [];

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = JSON.parse(JSON.stringify(SpecOutDetailsModule.currentSpecOut));
      this.desks = [];
      await AgencySettingsModule.getAgencyUsers();
      await AgencySettingsModule.getBranches();
      await SpecOutDetailsModule.searchWorkerProfiles();
      // Re-assign objects from loaded lists so object references match
      if (this.entity.owner) {
        const found = this.agencyUsers.find((u: any) => u.id === this.entity.owner.id);
        if (found) {
          this.entity.owner = found;
        }
      }
      if (this.entity.branch) {
        const found = this.branches.find((b: BranchDto) => b.id === this.entity.branch.id);
        if (found) {
          this.entity.branch = found;
          this.desks = found.desks;
          // Re-assign desk from loaded branch desks
          if (this.entity.desk) {
            const deskFound = found.desks.find((d: DeskDto) => d.id === this.entity.desk.id);
            if (deskFound) {
              this.entity.desk = deskFound;
            }
          }
        }
      }
    }
  }

  @Watch('entity.branch')
  onBranchChanged(newVal: BranchDto, oldVal: BranchDto) {
    if (newVal) {
      this.desks = newVal.desks;
    } else {
      this.entity.desk = null;
      this.desks = [];
    }
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get workerProfiles() {
    return SpecOutDetailsModule.workerProfiles;
  }

  get loading() {
    return SpecOutDetailsModule.loadingDialog;
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new UpdateSpecOutGeneralDetailsRequest();
    request.updatedAt = this.entity.updatedAt;
    if (this.entity.owner) {
      request.ownerId = this.entity.owner.id;
    }
    if (this.entity.branch) {
      request.branchId = this.entity.branch.id;
    }
    if (this.entity.desk) {
      request.deskId = this.entity.desk.id;
    } else {
      request.deskId = null;
    }
    request.workerId = this.entity.workerId;

    await SpecOutDetailsModule.editSpecOutGeneralDetails(request);
    this.dialog = false;
  }
}
